(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      if (this.getAttribute('data-sticky-type') === 'none') return;

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kr-campaign"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('kr-campaign'))customElements.define('kr-campaign',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;this.ready=true;this.index=0;this.slides=Array.from(this.querySelectorAll('[data-kr-slide]'));this.dots=Array.from(this.querySelectorAll('[data-kr-dot]'));
      const controls=this.querySelector('.kr-campaign__controls');if(controls)controls.hidden=false;
      this.querySelector('[data-kr-prev]')?.addEventListener('click',()=>this.show(this.index-1));this.querySelector('[data-kr-next]')?.addEventListener('click',()=>this.show(this.index+1));
      this.dots.forEach((dot,i)=>dot.addEventListener('click',()=>this.show(i)));
      this.addEventListener('keydown',e=>{if(e.target.closest('a'))return;if(e.key==='ArrowRight'){e.preventDefault();this.show(this.index+1)}if(e.key==='ArrowLeft'){e.preventDefault();this.show(this.index-1)}});
      this.onBlockSelect=e=>{const i=this.slides.findIndex(s=>s.dataset.blockId===e.detail.blockId);if(i>=0)this.show(i)};document.addEventListener('shopify:block:select',this.onBlockSelect);
    }
    disconnectedCallback(){document.removeEventListener('shopify:block:select',this.onBlockSelect);this.ready=false}
    show(index){this.index=(index+this.slides.length)%this.slides.length;this.slides.forEach((slide,i)=>{slide.hidden=i!==this.index;slide.classList.toggle('is-active',i===this.index)});this.dots.forEach((dot,i)=>dot.setAttribute('aria-pressed',String(i===this.index)))}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kr-edit-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kr-edit-tabs')) customElements.define('kr-edit-tabs', class extends HTMLElement {
    connectedCallback() {
      this.refresh = () => this.setup();
      this.select = event => {
        const entry = this.entries?.find(item => item.panel === event.target || item.panel.contains(event.target) || item.link === event.target || item.link.contains(event.target));
        if (entry) this.activate(this.entries.indexOf(entry));
      };
      document.addEventListener('DOMContentLoaded', this.refresh, {once: true});
      ['shopify:section:load', 'shopify:section:reorder', 'shopify:section:unload'].forEach(name => document.addEventListener(name, this.refresh));
      ['shopify:section:select', 'shopify:block:select'].forEach(name => document.addEventListener(name, this.select));
      this.setup();
    }
    disconnectedCallback() {
      this.reset();
      document.removeEventListener('DOMContentLoaded', this.refresh);
      ['shopify:section:load', 'shopify:section:reorder', 'shopify:section:unload'].forEach(name => document.removeEventListener(name, this.refresh));
      ['shopify:section:select', 'shopify:block:select'].forEach(name => document.removeEventListener(name, this.select));
    }
    reset() {
      this.entries?.forEach(({link, panel}) => {
        panel.hidden = false;
        panel.classList.remove('kr-tab-panel');
        panel.removeAttribute('role');
        panel.removeAttribute('aria-labelledby');
        ['role', 'aria-selected', 'aria-controls', 'tabindex'].forEach(name => link.removeAttribute(name));
        link.onclick = null;
        link.onkeydown = null;
      });
      this.querySelector('.kr-edit-tabs__buttons')?.removeAttribute('role');
      this.entries = [];
    }
    activate(index) {
      this.activeCollection = this.entries[index]?.link.dataset.krCollection;
      this.entries.forEach(({link, panel}, i) => {
        link.setAttribute('aria-selected', String(i === index));
        link.tabIndex = i === index ? 0 : -1;
        panel.hidden = i !== index;
      });
    }
    setup() {
      this.reset();
      const links = Array.from(this.querySelectorAll('[data-kr-collection]'));
      const candidates = [];
      let sibling = this.closest('.shopify-section')?.nextElementSibling;
      while (sibling && !sibling.querySelector('kr-edit-tabs')) {
        const panel = sibling.querySelector('[data-kr-tab-collection]');
        if (panel) candidates.push(panel);
        sibling = sibling.nextElementSibling;
      }
      const entries = links.map(link => ({link, panel: candidates.find(panel => panel.dataset.krTabCollection === link.dataset.krCollection)?.closest('.shopify-section')}));
      if (entries.length < 2 || entries.some(entry => !entry.panel) || new Set(entries.map(entry => entry.panel)).size !== entries.length) return;
      this.entries = entries;
      this.querySelector('.kr-edit-tabs__buttons').setAttribute('role', 'tablist');
      entries.forEach(({link, panel}, i) => {
        link.id = this.closest('.shopify-section').id + '-tab-' + i;
        link.setAttribute('role', 'tab');
        link.setAttribute('aria-controls', panel.id);
        panel.classList.add('kr-tab-panel');
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', link.id);
        link.onclick = event => {event.preventDefault(); this.activate(i);};
        link.onkeydown = event => {
          const keys = {ArrowRight: (i + 1) % entries.length, ArrowLeft: (i + entries.length - 1) % entries.length, Home: 0, End: entries.length - 1};
          if (!(event.key in keys)) return;
          event.preventDefault();
          this.activate(keys[event.key]);
          entries[keys[event.key]].link.focus();
        };
      });
      const active = entries.findIndex(entry => entry.link.dataset.krCollection === this.activeCollection);
      this.activate(active < 0 ? 0 : active);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kr-shipping-marquee"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('kr-shipping-marquee'))customElements.define('kr-shipping-marquee',class extends HTMLElement{
    connectedCallback(){if(this.ready)return;this.ready=true;this.querySelector('button').addEventListener('click',e=>{const paused=this.classList.toggle('is-paused');e.currentTarget.setAttribute('aria-pressed',String(paused));e.currentTarget.textContent=paused?'▶':'Ⅱ'})}
  });

  } catch(e) { console.error(e); }
})();
})();
